import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import classnames from 'classnames';

import './table_status_badge.scss';

const TableStatusBadge = props => {
  const { task } = props;
  const isDraft = task.draft;
  const assignmentDate = task.start_date;
  const assignedPeople = _.get(task, 'people', []);
  const isPaused = task.paused;

  let status = _.get(task, 'type_task_status.code');
  const stage = _.get(task, 'type_task_status.stage');
  let label = _.get(task, 'type_task_status.name');

  const overdue =
    stage !== 'finished' && assignmentDate && moment(assignmentDate).isBefore(moment(), 'day');

  if (isDraft) {
    label = 'Draft';
  }

  if (overdue) {
    if (status === 'created') {
      label = 'Overdue';
    }
    status = 'overdue';
  }

  if (status === 'created' && !isDraft) {
    return null;
  }

  const assigned = _.size(assignedPeople) > 0;
  const unAssigned = _.size(assignedPeople) === 0;

  return (
    <Badge
      color={status}
      className={classnames('table-status-badge', {
        'table-status-badge__paused': isPaused,
        draft: isDraft,
        'badge-draft': isDraft,
        'badge-assigned': assigned,
        'badge-unassigned': unAssigned,
      })}
    >
      {label}
    </Badge>
  );
};

TableStatusBadge.propTypes = {
  task: PropTypes.shape({
    draft: PropTypes.bool,
    paused: PropTypes.bool,
    start_date: PropTypes.string,
    type_task_status: PropTypes.shape({
      name: PropTypes.string,
      code: PropTypes.string,
    }),
    people: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

export default TableStatusBadge;
